'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')

var ScheduleList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region
      var device = options.device
      self.device = device
      self.layout = self.getLayoutView(device)

      //
      self.schedules = App.globalChannel.request('schedule:entities', {query: {device_id: self.device.get('_id')}})

      this.listenTo(self.layout, 'render', self.scheduleListRegion)

      // events
      this.listenTo(self.layout, 'schedule:add', function () {
        App.globalChannel.trigger('schedule:new', {device: self.device, collection: self.schedules})
      })
      this.listenTo(self.layout, 'timeline:next', () => { self.schedules.getNextPage() })

      self.region.show(self.layout)
    },
    /* Regions --------------------------------------------------------------- */
    scheduleListRegion: function () {
      var self = this

       //
      var emptyViewModel = new Backbone.Model({
        title: 'No schedules yet.',
        subTitle: 'create a schedule to get started'
      })

      var scheduleListView = self.getScheduleListView(self.schedules.fullCollection, emptyViewModel)

      scheduleListView.on('childview:timeline-item:delete', function (args) {
        var model = args.model
        model.destroy()
      })
      scheduleListView.on('childview:timeline-item:edit', function (args) {
        App.globalChannel.trigger('schedule:edit', {model: args.model, device: self.device})
      })

      self.layout.showChildView('scheduleRegion', scheduleListView)
    },
    /* Event methods --------------------------------------------------------- */
    /* Views ----------------------------------------------------------------- */
    getScheduleListView: function (schedules, model) {
      return new View.TimelineView({collection: schedules, model: model})
    },
    getLayoutView: function (device) {
      return new View.Layout({model: device})
    }
  })

  return new Controller(options)
}

module.exports = ScheduleList



// WEBPACK FOOTER //
// ./js/modules/schedules/list/index.js